import React, { useState } from "react";
import { Box, Paper, Typography, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import {
  CheckBill,
  IdentificationMode,
} from "../components/CheckBill/CheckBill";
import { buildGasInvoicePaymentUrl } from "./GasInvoicePayment";

export function PreBillPayment() {
  const [mode, setMode] = useState<IdentificationMode>("gas_account");

  return (
    <Box>
      <Paper
        sx={{
          p: 3,
          pb: 0,
          borderRadius: 3,
          maxWidth: 1280,
          mx: "auto",
          textAlign: "right",
        }}
        elevation={0}
      >
        <Typography fontWeight={800} fontSize={26} sx={{ textAlign: "left" }}>
          תשלום חשבון גז
        </Typography>

        <Typography
          fontWeight={800}
          fontSize={19}
          sx={{ mb: 0, textAlign: "left" }}
        >
          על פי מה לזהות אותך:
        </Typography>

        <RadioGroup
          row
          value={mode}
          onChange={(e) => setMode(e.target.value as IdentificationMode)}
          sx={{
            gap: 3,
            "& .MuiFormControlLabel-label": {
              fontSize: 20,
              fontWeight: 800,
            },
          }}
        >
          <FormControlLabel
            value="gas_account"
            control={<Radio />}
            label="פרטי חשבון גז"
          />
          <FormControlLabel
            value="gas_account_id"
            control={<Radio />}
            label="ת.ז ומספר צרכן"
          />
          <FormControlLabel
            value="id_mobile"
            control={<Radio />}
            label="טלפון ומס' צרכן"
          />
        </RadioGroup>
      </Paper>

      <CheckBill
        mode={mode}
        onSuccess={(payload) => {
          const nextUrl = buildGasInvoicePaymentUrl({
            logisticNumber: payload.customerCode,
            identificationType: payload.identificationType,
            identificationValue: payload.identificationValue,
            firmCode: payload.firmCode,
          });
           console.log("nextUrl ", nextUrl);
          window.location.assign(nextUrl);
        }}
      />
    </Box>
  );
}
